module.exports = __webpack_public_path__ + "static/cercazone_centro1-2a9309828d40d98aac4c4a41b9246a07.jpg";